import React from 'react';
import { styled } from "@mui/material/styles";
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { RgbaColorPicker } from 'react-colorful';

const PREFIX = 'colorModification'

const classes = {
  colorPicker: `${PREFIX}-colorPicker`,
  topLine: `${PREFIX}-topLine`,
  visualizeColor: `${PREFIX}-visualizeColor`,
}

const ColorModificationContainer = styled('div')((
  {
    theme
  }
) => {
  return {
    [`& .${classes.colorPicker}`]: {
      marginBottom: '1rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    [`& .${classes.topLine}`]: {
      margin: '1rem 0',
      display: 'flex',
      justifyContent: 'space-between'
    },
    [`& .${classes.visualizeColor}`]: {
      marginLeft: '1rem',
      width: '100px',
      height: '20px',
      borderRadius: '7px',
      border: `1px solid ${theme.palette.primary.main}`,
      transform: 'translateY(3px)'
    },
  }
})

const ColorModification = (props) => {
  const { t } = useTranslation();
  
  return (
    <ColorModificationContainer>
      <div className={classes.colorPicker}>
        <div className={classes.topLine}>
          <Typography
            variant="body1"
          >
            {t('configurator.selectedEventColor')}
          </Typography>
          <div
            className={classes.visualizeColor}
            style={{
              backgroundColor: `rgba(${props.element?.color.r}, ${props.element?.color.g}, ${props.element?.color.b}, ${props.element?.color.a}`,
            }}
          />
        </div>
        <RgbaColorPicker
          color={props.element?.color}
          onChange={color => props.handleChange({ ...props.element, color })}
        />
      </div>
    </ColorModificationContainer>
  )
}

export default ColorModification;